import { useRef, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './Tooltip.module.css';

const Tooltip = ({ children, content, className, position: propPosition, boxClassName, onMouseMove = false }) => {
    const triggerRef = useRef();
    const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState('top'); // For class names

    useEffect(() => {
        if (!visible || !triggerRef.current || onMouseMove) return;

        const rect = triggerRef.current.getBoundingClientRect();
        const tooltipEl = document.getElementById('tooltip-box');

        const spacing = 10;
        const tooltipHeight = tooltipEl?.offsetHeight || 40;
        const tooltipWidth = tooltipEl?.offsetWidth || 100;

        const space = {
            top: rect.top,
            bottom: window.innerHeight - rect.bottom,
            left: rect.left,
            right: window.innerWidth - rect.right,
        };

        let dir = 'top';
        let align = 'center';

        if (propPosition) {
            const split = propPosition.split(' ');
            dir = split[0] || 'top';
            align = split[1] || 'center';
        } else {
            if (space.bottom > tooltipHeight + spacing) dir = 'bottom';
            else if (space.top > tooltipHeight + spacing) dir = 'top';
            else if (space.right > tooltipWidth + spacing) dir = 'right';
            else if (space.left > tooltipWidth + spacing) dir = 'left';
        }

        setPosition(dir);

        const coords = {
            top: rect.top + window.scrollY,
            left: rect.left + window.scrollX,
        };

        if (dir === 'top') {
            coords.top -= tooltipHeight + spacing;
            if (align === 'center') coords.left += rect.width / 2 - tooltipWidth / 2;
            else if (align === 'left') coords.left = rect.left;
            else if (align === 'right') coords.left = rect.right - tooltipWidth;
        } else if (dir === 'bottom') {
            coords.top += rect.height + spacing;
            if (align === 'center') coords.left += rect.width / 2 - tooltipWidth / 2;
            else if (align === 'left') coords.left = rect.left;
            else if (align === 'right') coords.left = rect.right - tooltipWidth;
        } else if (dir === 'left') {
            coords.left -= tooltipWidth + spacing;
            if (align === 'center') coords.top += rect.height / 2 - tooltipHeight / 2;
            else if (align === 'top') coords.top = rect.top;
            else if (align === 'bottom') coords.top = rect.bottom - tooltipHeight;
        } else if (dir === 'right') {
            coords.left += rect.width + spacing;
            if (align === 'center') coords.top += rect.height / 2 - tooltipHeight / 2;
            else if (align === 'top') coords.top = rect.top;
            else if (align === 'bottom') coords.top = rect.bottom - tooltipHeight;
        }

        setTooltipPos(coords);
    }, [visible, propPosition, onMouseMove]);

    const tooltip = visible ? (
        <div
            id="tooltip-box"
            className={`${styles.tooltipBox} ${styles[position]} ${boxClassName}`}
            style={{
                top: `${tooltipPos.top}px`,
                left: `${tooltipPos.left}px`,
                position: 'absolute',
            }}
        >
            {content}
        </div>
    ) : null;

    // // inside Tooltip component (add these hooks near top)
    // const [cursorPos, setCursorPos] = useState({ x: -9999, y: -9999 });
    // const [showCursor, setShowCursor] = useState(false);

    return (
        <>
            <span
                ref={triggerRef}
                className={`${styles.tooltipTrigger} ${className}`} // ${onMouseMove ? styles.noCursor : ''}
                onMouseEnter={() => {
                    setVisible(true);
                    // if (onMouseMove) setShowCursor(true);
                }}
                onMouseLeave={() => {
                    setVisible(false);
                    // if (onMouseMove) setShowCursor(false);
                    // setCursorPos({ x: -9999, y: -9999 });
                }}
                onMouseMove={(e) => {
                    if (!onMouseMove) return;
                    const spacing = 20;
                    setTooltipPos({
                        top: e.clientY + (spacing - 25),
                        left: e.clientX + spacing
                    });
                    // setCursorPos({ x: e.clientX, y: e.clientY });
                }}
            >
                {children}
            </span>

            {ReactDOM.createPortal(tooltip, document.getElementById('tooltip-root'))}

            {/* Custom SVG cursor rendered in a portal (so it's not clipped) */}
            {/* {onMouseMove && showCursor &&
                ReactDOM.createPortal(
                    <div
                        className={styles.customCursor}
                        style={{
                            left: `${cursorPos.x}px`,
                            top: `${cursorPos.y}px`,
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g filter="url(#filter0_d)">
                                <path d="M15.0439 6.55754C15.4552 6.39761 15.6609 6.31761 15.7186 6.20454C15.7686 6.10661 15.7671 5.99025 15.7145 5.89363C15.6539 5.78211 15.4462 5.70757 15.0309 5.55847L4.43773 1.75581C4.09794 1.63383 3.92804 1.57284 3.81696 1.61131C3.7204 1.64475 3.6445 1.72063 3.61106 1.81721C3.5726 1.92827 3.63359 2.09817 3.75556 2.43797L7.5582 13.0311C7.7073 13.4465 7.78184 13.6541 7.89336 13.7148C7.98997 13.7673 8.10627 13.7689 8.20427 13.7189C8.31734 13.6611 8.39727 13.4555 8.55727 13.0442L10.2885 8.59247C10.3198 8.51194 10.3355 8.47167 10.3597 8.43774C10.3811 8.40767 10.4074 8.38141 10.4375 8.35994C10.4714 8.33574 10.5117 8.32007 10.5922 8.28874L15.0439 6.55754Z" fill="white" />
                                <path d="M15.0439 6.55754C15.4552 6.39761 15.6609 6.31761 15.7186 6.20454C15.7686 6.10661 15.7671 5.99025 15.7145 5.89363C15.6539 5.78211 15.4462 5.70757 15.0309 5.55847L4.43773 1.75581C4.09794 1.63383 3.92804 1.57284 3.81696 1.61131C3.7204 1.64475 3.6445 1.72063 3.61106 1.81721C3.5726 1.92827 3.63359 2.09817 3.75556 2.43797L7.5582 13.0311C7.7073 13.4465 7.78184 13.6541 7.89336 13.7148C7.98997 13.7673 8.10627 13.7689 8.20427 13.7189C8.31734 13.6611 8.39727 13.4555 8.55727 13.0442L10.2885 8.59247C10.3198 8.51194 10.3355 8.47167 10.3597 8.43774C10.3811 8.40767 10.4074 8.38141 10.4375 8.35994C10.4714 8.33574 10.5117 8.32007 10.5922 8.28874L15.0439 6.55754Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_d" x="-1" y="0" width="22" height="22">
                                    <feOffset dy="2" />
                                    <feGaussianBlur stdDeviation="1.55" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0
                                          0 0 0 0 0
                                          0 0 0 0 0
                                          0 0 0 0.25 0"/>
                                    <feBlend in="SourceGraphic" />
                                </filter>
                            </defs>
                        </svg>
                    </div>,
                    document.getElementById('tooltip-root')
                )
            } */}
        </>
    );
};

export default Tooltip;